/**
 * Store admin — collection detail (Commerce, M6).
 * @see prototype/store/admin/all.html#collections-detail
 */
import { createFileRoute } from "@tanstack/react-router";
import { CollectionDetailPage } from "../../../../../../features/store/collections/collection-detail-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/collections/$collectionId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { collectionId } = Route.useParams();
  return <CollectionDetailPage collectionId={collectionId} />;
}
